<template>
  <v-app>
    <v-navigation-drawer
      touchless
      app
      v-model="drawer"
      clipped
      style="z-index: 50000"
    >
      <v-container>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="title">メニュー</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>
        <v-list dense nav two-line>
          <v-list-item to="mobile_area" dense>
            <v-list-item-icon>
              <v-icon>mdi-map</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>携帯キャリア</v-list-item-title>
              <v-list-item-title>エリアマップ統合版</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item to="rakuten_own_area_map_only" dense>
            <v-list-item-icon>
              <v-icon>mdi-map</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>楽天モバイル</v-list-item-title>
              <v-list-item-title>自社回線エリア</v-list-item-title>
              <v-list-item-title>更新履歴（マップ）</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>

        <v-divider></v-divider>
        <v-list-item href="./beta/" dense>
          <v-list-item-icon>
            <v-icon>mdi-yoga</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-subtitle>試作品</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>
        <!-- <v-list-item
          href="https://twitter.com/sTlC2ozHVTECDsn"
          target="_blank"
          dense
        >
          <v-list-item-icon>
            <v-icon>mdi-twitter</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-subtitle>Twitter</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item> -->
      </v-container>
    </v-navigation-drawer>

    <v-app-bar color="primary" dark app dense style="z-index: 50000">
      <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>携帯キャリアエリア情報</v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- <v-toolbar-items>
        <v-btn icon href="https://twitter.com/sTlC2ozHVTECDsn" target="_blank">
          <v-icon>mdi-twitter</v-icon>
        </v-btn>
      </v-toolbar-items> -->
    </v-app-bar>

    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
export default {
  data() {
    return {
      drawer: null,
    };
  },
  mounted: function () {
    var routeInstance = this.$route;
    this.createTitleDesc(routeInstance);
  },
  watch: {
    $route(routeInstance) {
      this.createTitleDesc(routeInstance);
    },
  },
  methods: {
    createTitleDesc: function (routeInstance) {
      // タイトルを設定
      let title = "携帯キャリアエリア情報";
      if (routeInstance.meta.title) {
        title = routeInstance.meta.title + " | 携帯キャリアエリア情報";
      }
      document.title = title;

      // メタタグdescription設定
      if (routeInstance.meta.desc) {
        let desc = routeInstance.meta.desc;
        document
          .querySelector("meta[name='description']")
          .setAttribute("content", desc);
      }
    },
  },
};
</script>